import { render, staticRenderFns } from "./DriverMessages.vue?vue&type=template&id=37d643aa&scoped=true&"
import script from "./DriverMessages.vue?vue&type=script&lang=js&"
export * from "./DriverMessages.vue?vue&type=script&lang=js&"
import style0 from "./DriverMessages.vue?vue&type=style&index=0&id=37d643aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d643aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VProgressCircular,VTextarea})
